import React from 'react';
import PropTypes from 'prop-types';

function CommonHeaderCell({ className, style, headerName }) {
  return (
    <div className={className} style={style}>
      <span className="heatmap__common-headers__header-name">{headerName}</span>
    </div>
  );
}

CommonHeaderCell.propTypes = {
  className: PropTypes.string.isRequired,
  headerName: PropTypes.string.isRequired,
  style: PropTypes.object,
};

export default CommonHeaderCell;
